import { ExternalLink, Building2 } from 'lucide-react'
import styles from './IBMCloudPage.module.css'

const IBM_URL = 'https://selfserve.apteancloud.com/ibm-cloud'

export function IBMCloudPage() {
  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <div className={styles.headerLeft}>
          <div className={styles.headerIcon}>
            <Building2 size={20} />
          </div>
          <div>
            <h1 className={styles.pageTitle}>IBM Cloud</h1>
            <p className={styles.pageSubtitle}>IKS deployments, clusters, and resources</p>
          </div>
        </div>
      </div>

      <div className={styles.fallbackCard}>
        <Building2 size={48} className={styles.fallbackIcon} />
        <h2 className={styles.fallbackTitle}>IBM Cloud Portal</h2>
        <p className={styles.fallbackDesc}>
          The IBM Cloud portal cannot be embedded due to browser security restrictions
          on the external site. Open it in a new window to manage your IBM Cloud resources.
        </p>
        <a
          href={IBM_URL}
          target="_blank"
          rel="noreferrer"
          className={styles.openBtn}
        >
          <ExternalLink size={16} />
          Open IBM Cloud
        </a>
      </div>
    </div>
  )
}
